import React, { useState, useEffect, useRef } from "react";
import {  Tooltip, Button, Form, Container, Row, Col, Card, InputGroup, OverlayTrigger } from "react-bootstrap";
import axios from "axios";
import { BASE_URL } from "../../../constants";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../CommonCSS/SocietyCSS.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const New_Employe = () => {

  const initialFormData = {

    // 🎓Personal Details
    emp_id: '',
    emp_no: '',
    first_name: '',
    surname: '',
    father_name: '',
    mother_name: '',
    marital_status: '',
    spouse_name: '',
    dob: '',
    aadhar_no: '',
    biometric_id: '',
    status: 'A',
    gender_id: '1',
    emp_type: '',
    anniversary_date: '',
    pic_name: '',

    // 🏠 Communication
    curr_address: '',
    perm_address: '',
    curr_phone: '',
    perm_phone: '',
    mobile_no: '',
    email_id: '',
    emerg_cont_name: '',
    emerg_cont_rel: '',
    emerg_cont_no: '',
    emerg_cont_mobile: '',

    // Office Related Details 
    date_of_joining: '',
    service_end_date: '',
    designation_id: '',
    category_id: '',
    shift_id: '',
    reporting_to: '',
    section_id: '',
    employment_type: '',
    probation_end_date: '',
    sal_deduct_appl: '',
    pay_sal_by: '',
    login_id: '',

    // Employee Bank Details
    bank_name: '',
    bank_branch: '',
    ac_holder_name: '',
    bank_ac_no: '',
    ifsc: '',
    lcatg_id: '',

    /// Login Details
    loginId: '',
    userName: '',
    password: '',
    confrimPwd: '',
    userType: 'Normal',

  };

  const [isEditable, setIsEditable] = useState(false);
  const [formData, setFormData] = useState(initialFormData);
  const [file, setFile] = useState(null);
  const [savedImage, setSavedImage] = useState("");
  const fileInputRef = useRef(null);
//  const [userType, setUserType] = useState('Normal');
  const [errors, setErrors] = useState({});

  // DROPDOWNS
  const [ddlSections, setDdlSections] = useState([]);
  const [ddlGender, setDdlGender] = useState([]);
  const [ddlStatus, setDdlStatus] = useState([]);
 // const [ddlYesNo, setDdlYesNo] = useState([]);
  const [ddlAcademicYear, setDdlAcademicYear] = useState([]);
  const [catgMasters, setCatgMasters] = useState([]);
  const [desigMasters, setDesigMasters] = useState([]);
  const [ddlReportingTo, setDdlReportingTo] = useState([]);

  const [photoPreview, setPhotoPreview] = useState(null);

  const [roleDetails, setRoleDetails] = useState([{ role: '', valid_till: '', user_id: '' }]); //changed
  const [roles, setRoles] = useState([]);

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPhotoPreview(URL.createObjectURL(file));
    }
  };

  useEffect(() => {

    loadDropdowns();

  }, []);

  const loadDropdowns = async () => {
    try {

      const sec = await axios.get(`${BASE_URL}/api/ddl_sections`);

      setDdlSections(sec.data);

      setDdlGender([
        { id: 1, name: "Male" },
        { id: 2, name: "Female" }
      ]);

      setDdlStatus([
        { id: "A", name: "Active" },
        { id: "I", name: "Inactive" }
      ]);

      // setDdlYesNo([
      //   { id: "Y", name: "Yes" },
      //   { id: "N", name: "No" }
      // ]);

      await axios.get(`${BASE_URL}/api/get_roles`)
        .then(response => { setRoles(response.data) })
        .catch(error => console.error('Error Fetching Roles', error));

      /// Category 
      const resp_catg = await axios.get(`${BASE_URL}/api/ddl_Gen_Mst_Type`,
        { params: { type: 'CATG' } });

      if (resp_catg.data && resp_catg.data.length > 0) {
        setCatgMasters(resp_catg.data);
      }

      /// Designation
      const respdesig = await axios.get(`${BASE_URL}/api/ddl_Gen_Mst_Type`,
        { params: { type: 'DESIG' } });

      if (respdesig.data && respdesig.data.length > 0) {
        setDesigMasters(respdesig.data);
      }

      /// Reporting To
      const respReportTo = await axios.get(`${BASE_URL}/api/ddl_Reporting_To`);

      if (respReportTo.data && respReportTo.data.length > 0) {
        setDdlReportingTo(respReportTo.data);
      }
//ddlReportingTo, setDdlReportingTo
    } catch (err) {
      console.error(err);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSavedImage('');
    setFile(file);
    setFormData(prev => ({ ...prev, pic_name: file?.name || '' }));
  };

  const handleChange = (e) => {
 
    const { name, value } = e.target;

//    setFormData(prev => ({ ...prev, [name]: value }));
    setFormData(prev => {
      // 1. Calculate the new state for the field being changed
      const updatedData = { ...prev, [name]: value };

      // 2. If first_name or surname changed, update username as well
      if (name === "first_name" || name === "surname") {
        updatedData.username = `${updatedData.first_name}' '${updatedData.surname}`;
      }

      return updatedData;
    });


    setErrors(prev => ({
      ...prev,
      [name]: ""
    }));

  };

  const handleAcademicYear = (e) => {
    const yr = ddlAcademicYear.find(x => x.id === e.target.value);
    if (!yr) return;
    setFormData(prev => ({
      ...prev,
      academic_year1: yr.y1,
      academic_year2: yr.y2
    }));
  };

  const handleNew = () => {
    setFormData(initialFormData);
    setIsEditable(true);
    setSavedImage('');
  };

  const handleClear = () => {
    if (!window.confirm("Clear form?")) return;
    setFormData(initialFormData);
    setIsEditable(false);
    setFile(null);
    setSavedImage('');
  };

  const handleRoleInputChange = (index, field, value) => {

    const newDetails = [...roleDetails];

    newDetails[index][field] = value;

    setRoleDetails(newDetails);

  }

  const handleAddRow = () => {
    setRoleDetails([...roleDetails, { role: '', valid_till: '', user_id: '' }]) //changed
  }
  
  const handleDeleteRow = (index) => {
    if (roleDetails[index]?.user_id) { //changed
      alert('Previously saved role for this user can not be deleted.');
      return;
    }
    const deletedRow = roleDetails[index];
    const temp = roleDetails.filter((_, i) => i !== index);
    setRoleDetails(temp);
  }

  const handleSave = async () => {

    const newErrors = {};

    // ================= PERSONAL =================
    if (!formData.emp_no) {
      newErrors.emp_no = "Employee No is required";
      toast.error("Employee No is required");
    } else if (!formData.first_name) {
      newErrors.first_name = "First Name is required";
      toast.error("First Name is required");
    } else if (!formData.surname) {
      newErrors.surname = "Surname is required";
      toast.error("Surname is required");
    } else if (!formData.father_name) {
      newErrors.father_name = "Father Name is required";
      toast.error("Father Name is required");
    } else if (!formData.dob) {
      newErrors.dob = "Birth Date is required";
      toast.error("Birth Date is required");
    } else if (!formData.gender_id) {
      newErrors.gender_id = "Gender is required";
      toast.error("Gender is required");
    } else if (!formData.aadhar_no) {
      newErrors.aadhar_no = "Aadhar No is required";
      toast.error("Aadhar No is required");
    } else if (!formData.biometric_id) {
      newErrors.biometric_id = "Biometric ID is required";
      toast.error("Biometric ID is required");
    }

    // ================= COMMUNICATION =================
    else if (!formData.curr_address) {
      newErrors.curr_address = "Current Address is required";
      toast.error("Current Address is required");
    } else if (!formData.mobile_no) {
      newErrors.mobile_no = "Mobile Number is required";
      toast.error("Mobile Number is required");
    }

    // ================= OFFICE =================
    else if (!formData.date_of_joining) {
      newErrors.date_of_joining = "Joining Date is required";
      toast.error("Joining Date is required");
    } else if (!formData.category_id) {
      newErrors.category_id = "Category is required";
      toast.error("Category is required");
    } 
    // Temporarily
    // else if (!formData.shift_id) {
    //   newErrors.shift_id = "Shift is required";
    //   toast.error("Shift is required");
    // } 
    else if (!formData.reporting_to) {
      newErrors.reporting_to = "Reporting To is required";
      toast.error("Reporting To is required");
    } else if (!formData.section_id) {
      newErrors.section_id = "Section is required";
      toast.error("Section is required");
    } else if (!formData.employment_type) {
      newErrors.employment_type = "Employment Type is required";
      toast.error("Employment Type is required");
    } else if (!formData.sal_deduct_appl) {
      newErrors.sal_deduct_appl = "Salary Deduction Type is required";
      toast.error("Salary Deduction Type is required");
    } else if (!formData.pay_sal_by) {
      newErrors.pay_sal_by = "Pay Salary By is required";
      toast.error("Pay Salary By is required");
    } 
    //// Login Details

    else if (!formData.loginId) {
      newErrors.loginId = "Login Id is required";
      toast.error("Login Id is required");
    } else if (!formData.password) {
      newErrors.password = "Password is required";
      toast.error("Password is required");
    } else if (!formData.confrimPwd) {
      newErrors.confrimPwd = "Confirm Password is required";
      toast.error("Confirm Password is required");
    } else if (formData.password !== formData.confrimPwd) {
      newErrors.confrimPwd = "Password and Confirm Password must match";
      toast.error("Password and Confirm Password must match");
    } 



    // ================= FINAL =================
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      const firstErrorKey = Object.keys(newErrors)[0];
      if (firstErrorKey) {
        const el = document.getElementsByName(firstErrorKey)[0];
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
          el.focus(); // 🔥 bonus (cursor goes there)
        }
      }
      return;
    }

    // ================= ROLE =================
    const validRoles = roleDetails.filter(r => r.role);

    if (validRoles.length === 0) {
      toast.error("At least one role must be selected");
      return;
    }

    if (!window.confirm("Save Employee Record ?")) return;

    try {

      const response = await axios.post(`${BASE_URL}/api/save_employee`, {
                                          formData, roleDetails});

      if (response.data.message === '1') {
        if (file) {
          try {
            const photoData = new FormData();
            photoData.append("file", file);
            photoData.append("emp_id", response.data.emp_id);
            photoData.append("emp_name", formData.first_name);
            await axios.post(`${BASE_URL}/api/upload_Emp_Pic`, photoData);

          } catch (err) {
            console.log('Error uploading Owner Photo : ', err);
          }
        }
        toast.success("Employee saved successfully");
        setIsEditable(false);
        setFormData(initialFormData);
        setRoleDetails([{ role: '', valid_till: '', user_id: '' }]);
        setFile(null);
        setSavedImage('');
        setErrors({});
      }

    } catch (err) {
      console.error(err);
      toast.error("Error saving student");
    }

    
  };


  return (
    <Container fluid className="p-3" style={{ maxHeight: "90vh", overflowY: "auto" }}>

      {/* ================= PERSONAL DETAILS ================= */}
      <Card className="mb-4">
        <Card.Header
          className="fw-bold" style={{ backgroundColor: "#c3cdf0", color: "black" }}>
          👤 Personal Details
        </Card.Header>
        <Card.Body>

          <Row>
            <Col md={8}>
              <Row className="mb-3">
                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>Employee No<span style={{ color: "red" }}>*</span></InputGroup.Text>
                    <input name="emp_no" placeholder="Employee No" 
                       //className="form-control"
                       className={`form-control ${errors.emp_no ? "is-invalid" : ""}`}
                      value={formData.emp_no} onChange={handleChange} disabled={!isEditable} />
                  </InputGroup>
                </Col>
                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>Status</InputGroup.Text>
                    <select name="status" className="form-select"
                      value={formData.status} onChange={handleChange} disabled={!isEditable}>
                      {ddlStatus.map(s => (
                        <option key={s.id} value={s.id}>{s.name}</option>
                      ))}
                    </select>
                  </InputGroup>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>First Name<span style={{ color: "red" }}>*</span></InputGroup.Text>
                    <input name="first_name" placeholder="First Name" 
                       //className="form-control"
                      value={formData.first_name} onChange={handleChange} 
                      className={`form-control ${errors.first_name ? "is-invalid" : ""}`}
                      disabled={!isEditable} />
                  </InputGroup>
                </Col>
                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>Surname<span style={{ color: "red" }}>*</span></InputGroup.Text>
                    <input name="surname" placeholder="Surname" 
                       //className="form-control"
                       className={`form-control ${errors.surname ? "is-invalid" : ""}`}
                      value={formData.surname} onChange={handleChange} disabled={!isEditable} />
                  </InputGroup>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>Father Name<span style={{ color: "red" }}>*</span></InputGroup.Text>
                    <input name="father_name" placeholder="Father Name" 
                    className={`form-control ${errors.father_name ? "is-invalid" : ""}`}
                    //className="form-control"
                      value={formData.father_name} onChange={handleChange} disabled={!isEditable} />
                  </InputGroup>
                </Col>
                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>Mother Name </InputGroup.Text>
                    <input name="mother_name" placeholder="Mother Name" className="form-control"
                      value={formData.mother_name} onChange={handleChange} disabled={!isEditable} />
                  </InputGroup>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>
                      Marital Status
                    </InputGroup.Text>
                    <select
                      className="form-select"
                      name="marital_status"
                      value={formData.marital_status}
                      disabled={!isEditable}
                      onChange={handleChange}
                    >
                      <option value="">-- Select Marital Status--</option>
                      <option value="M">Married</option>
                      <option value="Un">UnMarried</option>
                      <option value="D">Divorced</option>
                      <option value="W">Widow</option>
                      <option value="Wi">Widowed</option>
                    </select>
                  </InputGroup>
                </Col>
                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>Spouse Name</InputGroup.Text>
                    <input name="spouse_name" placeholder="Spouse Name" 
                    className="form-control"
                    //className={`form-control ${errors.spouse_name ? "is-invalid" : ""}`}
                      value={formData.spouse_name} onChange={handleChange} disabled={!isEditable} />
                  </InputGroup>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>Birth Date<span style={{ color: "red" }}>*</span></InputGroup.Text>
                    <input type="date" name="dob" 
                      /// className="form-control"
                      className={`form-control ${errors.dob ? "is-invalid" : ""}`}
                      value={formData.dob} onChange={handleChange} disabled={!isEditable} />
                  </InputGroup>
                </Col>
                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>Gender<span style={{ color: "red" }}>*</span></InputGroup.Text>
                    <select name="gender_id" 
                      //className="form-select"
                      className={`form-select ${errors.gender_id ? "is-invalid" : ""}`}
                      value={formData.gender_id} onChange={handleChange} disabled={!isEditable}>
                      {ddlGender.map(g => (
                        <option key={g.id} value={g.id}>{g.name}</option>
                      ))}
                    </select>
                  </InputGroup>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>Adhar No<span style={{ color: "red" }}>*</span></InputGroup.Text>
                    <input name="aadhar_no" placeholder="Adhar No" 
                       //className="form-control"
                       className={`form-control ${errors.aadhar_no ? "is-invalid" : ""}`}
                      value={formData.aadhar_no} onChange={handleChange} disabled={!isEditable} />
                  </InputGroup>
                </Col>

                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>Biomatric Id<span style={{ color: "red" }}>*</span></InputGroup.Text>
                    <input name="biometric_id" placeholder="Biomatric Id" 
                      //className="form-control"
                      className={`form-control ${errors.biometric_id ? "is-invalid" : ""}`}
                      value={formData.biometric_id} onChange={handleChange} disabled={!isEditable} />
                  </InputGroup>
                </Col>
              </Row>
            </Col>
            {/* ************************************************************************************************************************************* */}
            {/* ********************************************  Start : Photo Section   *************************************************************** */}
            <Col md={4} className="text-center">

              <div style={{ border: "1px solid #ccc", padding: "10px" }}>
                <div>
                  <strong>Employe Photo</strong>
                </div>
                <div style={{ height: "200px", background: "#f8f9fa", display: "flex", alignItems: "center", justifyContent: "center", border: "1px dashed #aaa" }}
                // className="my-2"
                >
                  {file ? (
                    <img src={URL.createObjectURL(file)} alt="preview" style={{ maxHeight: "100%", maxWidth: "100%", objectFit: "contain", display: "block" }} />
                  ) : savedImage ? <img src={savedImage} alt="saved" style={{ maxHeight: "100%", maxWidth: "100%", objectFit: "contain", display: "block" }} /> :
                    (
                      <div style={{ height: "150px", background: "#f8f9fa", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        No Image
                      </div>
                    )}
                </div>
                <input type="file" className="form-control" onChange={handleFileChange}
                  disabled={!isEditable} style={{ marginTop: "5px" }} ref={fileInputRef} />
              </div>
            </Col>

            {/* **********************************************  End : Photo Section   *************************************************************** */}
            {/* ************************************************************************************************************************************* */}
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>
                  Leave Appr <span style={{ color: "red" }}>*</span>
                </InputGroup.Text>

                <div className="form-control d-flex align-items-center gap-3">

                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="emp_type"
                      value="MD"
                      checked={formData.emp_type === "MD"}
                      onChange={handleChange}
                      disabled={!isEditable}
                    />
                    <label className="form-check-label">Director</label>
                  </div>

                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="emp_type"
                      value="HM"
                      checked={formData.emp_type === "HM"}
                      onChange={handleChange}
                      disabled={!isEditable}
                    />
                    <label className="form-check-label">HM</label>
                  </div>

                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="emp_type"
                      value="SUP"
                      checked={formData.emp_type === "SUP"}
                      onChange={handleChange}
                      disabled={!isEditable}
                    />
                    <label className="form-check-label">Supervisor</label>
                  </div>

                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="emp_type"
                      value="OTH"
                      checked={formData.emp_type === "OTH"}
                      onChange={handleChange}
                      disabled={!isEditable}
                    />
                    <label className="form-check-label">Other</label>
                  </div>

                </div>
              </InputGroup>
            </Col>

            {/* ================= ACTIONS ================= */}
            <Col md={6}>
              <div className="text-end">
                <button
                  className="btn btn-primary me-2"
                  style={{ width: "135px" }}
                  onClick={handleNew}
                  disabled={isEditable}>
                  New
                </button>

                <button
                  className="btn btn-secondary me-2"
                  style={{ width: "135px" }}
                  onClick={handleClear}>
                  Clear
                </button>

                <button
                  className="btn btn-success"
                  style={{ width: "135px" }}
                  onClick={handleSave}
                  disabled={!isEditable}>
                  Save
                </button>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* ================= COMMUNICATION ================= */}

      {/* `<Card className="mb-3 p-3"> */}
      <Card className="mb-4">
        <Card.Header className="fw-bold" style={{ backgroundColor: "#c3cdf0", color: "black" }}>
          🏠 Communication Details
        </Card.Header>
        <Card.Body>

          <Row className="mb-3">
            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}> Current Add  <span style={{ color: "red" }}>*</span></InputGroup.Text>
                <input name="curr_address" placeholder="Current Address " 
                  //className="form-control"
                  className={`form-control ${errors.curr_address ? "is-invalid" : ""}`}
                  value={formData.curr_address} onChange={handleChange} disabled={!isEditable} />
              </InputGroup>
            </Col>

            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}> Perm Add </InputGroup.Text>
                <input name="perm_address" placeholder="Permanent Address" className="form-control"
                  value={formData.perm_address} onChange={handleChange} disabled={!isEditable} />
              </InputGroup>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}> Current Phone </InputGroup.Text>
                <input name="curr_phone" placeholder="Current Phone" className="form-control"
                  value={formData.curr_phone} onChange={handleChange} disabled={!isEditable} />
              </InputGroup>
            </Col>

            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}> 	Perm Phone </InputGroup.Text>
                <input name="perm_phone" placeholder="Permanent Phone" className="form-control"
                  value={formData.perm_phone} onChange={handleChange} disabled={!isEditable} />
              </InputGroup>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}> Mobile No. <span style={{ color: "red" }}>*</span></InputGroup.Text>
                <input name="mobile_no" placeholder="Mobile No." 
                //className="form-control"
                className={`form-control ${errors.mobile_no ? "is-invalid" : ""}`}
                  value={formData.mobile_no} onChange={handleChange} disabled={!isEditable} />
              </InputGroup>
            </Col>

            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}> Email-Id </InputGroup.Text>
                <input name="email_id" placeholder="Email-Id" className="form-control"
                  value={formData.email_id} onChange={handleChange} disabled={!isEditable} />
              </InputGroup>
            </Col>
          </Row>


          <Row className="mb-3">
            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "160px" }}> Emg Contact  Name </InputGroup.Text>
                <input name="emerg_cont_name" placeholder="Emergency contact Name" className="form-control"
                  value={formData.emerg_cont_name} onChange={handleChange} disabled={!isEditable} />
              </InputGroup>
            </Col>

            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Relation</InputGroup.Text>
                <input name="emerg_cont_rel" placeholder="Emg contact Relation" className="form-control"
                  value={formData.emerg_cont_rel} onChange={handleChange} disabled={!isEditable} />
              </InputGroup>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Contact No. </InputGroup.Text>
                <input name="emerg_cont_no" placeholder="Emg contact No." className="form-control"
                  value={formData.emerg_cont_no} onChange={handleChange} disabled={!isEditable} />
              </InputGroup>
            </Col>

            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "145px" }}> Emg Contact Mob </InputGroup.Text>
                <input name="emerg_cont_mobile" placeholder="Emg contact Mobile" className="form-control"
                  value={formData.emerg_cont_mobile} onChange={handleChange} disabled={!isEditable} />
              </InputGroup>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* ================= Office Related Details ================= */}

      {/* <Card className="mb-3 p-3"> */}
      <Card className="mb-4">
        <Card.Header
          className="fw-bold"
          style={{ backgroundColor: "#e0a575", color: "black" }}>
         💼 Office Related Details
        </Card.Header>
        <Card.Body>



          <Row className="mb-3">
            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Joining Date<span style={{ color: "red" }}>*</span></InputGroup.Text>
                <input type="date" name="date_of_joining" //className="form-control"
                  className={`form-control ${errors.date_of_joining ? "is-invalid" : ""}`}
                  value={formData.date_of_joining || ""}
                  onChange={handleChange} disabled={!isEditable} />
              </InputGroup>
            </Col>

            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "150px" }}>Last Working Date</InputGroup.Text>
                <input type="date" name="service_end_date" className="form-control"
                  value={formData.service_end_date || ""}
                  onChange={handleChange} disabled={!isEditable} />
              </InputGroup>
            </Col>
          </Row>

          <Row className="mb-3">

            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Designation</InputGroup.Text>
                <select name="designation_id" className="form-select"
                  value={formData.designation_id || ""}
                  onChange={handleChange} disabled={!isEditable}>
                  <option value="">-- Select Designation --</option>
                  {desigMasters.map(gm => (
                    <option key={gm.gen_id} value={gm.gen_id}>{gm.gen_desc}</option>
                  ))}
                </select>
              </InputGroup>
            </Col>

            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Category<span style={{ color: "red" }}>*</span></InputGroup.Text>
                <select name="category_id" //className="form-select"
                  className={`form-select ${errors.category_id ? "is-invalid" : ""}`}
                  value={formData.category_id}
                  onChange={handleChange} disabled={!isEditable}>
                  <option value="">-- Select Category --</option>
                  {catgMasters.map(gm => (
                    <option key={gm.gen_id} value={gm.gen_id}>{gm.gen_desc}</option>
                  ))}
                </select>
              </InputGroup>
            </Col>
          </Row>

          <Row className="mb-3">

            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Shift<span style={{ color: "red" }}>*</span></InputGroup.Text>
                <select name="shift_id" //className="form-select"
                  className={`form-select ${errors.shift_id ? "is-invalid" : ""}`}
                  value={formData.shift_id || ""}
                  onChange={handleChange} disabled={!isEditable}>
                  <option value="">-- Select Shift --</option>
                </select>
              </InputGroup>
            </Col>

            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Reporting To<span style={{ color: "red" }}>*</span></InputGroup.Text>
                <select name="reporting_to" //className="form-select"
                  className={`form-select ${errors.reporting_to ? "is-invalid" : ""}`}
                  value={formData.reporting_to || ""}
                  onChange={handleChange} disabled={!isEditable}>
                  <option value="">-- Select Reporting to --</option>
                  {ddlReportingTo.map(rt => (
                    <option key={rt.emp_id} value={rt.emp_id}>{rt.emp_name}</option>
                  ))}
                </select>
              </InputGroup>
            </Col>
          </Row>


          <Row className="mb-3">
            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Section<span style={{ color: "red" }}>*</span></InputGroup.Text>
                <select name="section_id" //className="form-select"
                  className={`form-select ${errors.section_id ? "is-invalid" : ""}`}
                  value={formData.section_id || ""}
                  onChange={handleChange} disabled={!isEditable}>
                  <option value="">-- Select Section --</option>
                  {ddlSections.map(sec => (
                    <option key={sec.section_id} value={sec.section_id}>{sec.section_desc}</option>
                  ))}
                </select>
              </InputGroup>
            </Col>

            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Emp Type<span style={{ color: "red" }}>*</span></InputGroup.Text>
                <select name="employment_type" //className="form-select"
                className={`form-select ${errors.employment_type ? "is-invalid" : ""}`}
                  value={formData.employment_type || ""}
                  onChange={handleChange} disabled={!isEditable}>
                  <option value="">-- Select Employment Type --</option>
                  <option value="PERM">Permanent</option>
                  <option value="PROB">Probation</option>
                  <option value="CONTR">Contract</option>
                  <option value="TEMP"> Temporary </option>
                </select>
              </InputGroup>
            </Col>
          </Row>

          <Row className="mb-3">


            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }} t>Prob End Date</InputGroup.Text>
                <input
                  name="probation_end_date"
                  className="form-control"
                  value={formData.probation_end_date || ""}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </InputGroup>
            </Col>

            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Deduction Appl<span style={{ color: "red" }}>*</span></InputGroup.Text>
                <select name="sal_deduct_appl" //className="form-select"
                  className={`form-select ${errors.sal_deduct_appl ? "is-invalid" : ""}`}
                  value={formData.sal_deduct_appl || ""}
                  onChange={handleChange} disabled={!isEditable}>
                  <option value="0">-- Select Salary deduction Type --</option>
                  <option value="1">No Salary Deduction</option>
                  <option value="2">Normal Salary Deduction</option>
                  <option value="3">Double Salary Deduction</option>
                </select>
              </InputGroup>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Pay Salary By <span style={{ color: "red" }}>*</span></InputGroup.Text>
                <select name="pay_sal_by" //className="form-select"
                  className={`form-select ${errors.pay_sal_by ? "is-invalid" : ""}`}
                  value={formData.pay_sal_by || ""}
                  onChange={handleChange} disabled={!isEditable}>
                  <option value="">-- Select Payment Mode --</option>
                  <option value="CASH">Cash</option>
                  <option value="CHQ">By Cheque</option>
                  <option value="NEFT">NEFT</option>
                </select>
              </InputGroup>
            </Col>

            {/* <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Login Id<span style={{ color: "red" }}>*</span></InputGroup.Text>
                <select name="login_id" className="form-select"
                  value={formData.login_id || ""}
                  onChange={handleChange} disabled={!isEditable}>
                  <option value="">-- Select User Login --</option>
                </select>
              </InputGroup>
            </Col> */}
          </Row>
          <hr />
        </Card.Body>
      </Card>


      {/* ================= OTHER DETAILS ================= */}

      <Card className="mb-4">
        <Card.Header className="fw-bold" style={{ backgroundColor: "#c8f7c5", color: "black" }}>
          🏦 Employee Bank Details
        </Card.Header>
        <Card.Body>

          <Row className="mb-3">
            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Bank Name</InputGroup.Text><input
                  name="bank_name"
                  placeholder="Bank Name"
                  //className="form-control"
                  className={`form-control ${errors.bank_name ? "is-invalid" : ""}`}
                  value={formData.bank_name}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </InputGroup>
            </Col>

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Bank Branch</InputGroup.Text><input
                  name="bank_branch"
                  placeholder="Bank Branch"
                  //className="form-control"
                  className={`form-control ${errors.bank_branch ? "is-invalid" : ""}`}
                  value={formData.bank_branch}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </InputGroup>
            </Col>

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Acc Holder Name</InputGroup.Text><input
                  name="ac_holder_name"
                  placeholder="Acc Holder Name"
                  //className="form-control"
                  className={`form-control ${errors.ac_holder_name ? "is-invalid" : ""}`}
                  value={formData.ac_holder_name}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </InputGroup>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Bank Acc No.</InputGroup.Text><input
                  name="bank_ac_no"
                  placeholder="Bank Acc No."
                  //className="form-control"
                  className={`form-control ${errors.bank_ac_no ? "is-invalid" : ""}`}
                  value={formData.bank_ac_no}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </InputGroup>
            </Col>

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>IFSC</InputGroup.Text><input
                  name="ifsc"
                  placeholder="IFSC"
                  className="form-control"
                  value={formData.ifsc}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </InputGroup>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* ================= LOGIN DETAILS ================= */}

      <Card className="mb-4">
        <Card.Header className="fw-bold" style={{ backgroundColor: "#e0ccff", color: "black" }}>
          🔐 Login Details
        </Card.Header>
        <Card.Body>

          <Row className="mb-3">
            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: '200px', backgroundColor: "#e0ccff" }}>Login Id <span style={{ color: "red" }}>*</span></InputGroup.Text>
                <Form.Control type="text" name="loginId" value={formData.loginId}
                  className={`${errors.loginId ? "is-invalid" : ""}`}
                  disabled={!isEditable} onChange={handleChange} />
              </InputGroup>
            </Col>
            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: '200px', backgroundColor: "#e0ccff" }}>User Name </InputGroup.Text>
                <Form.Control type="text" name="userName" value={formData.userName} disabled />
              </InputGroup>
            </Col>

          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: '200px', backgroundColor: "#e0ccff" }}>Password <span style={{ color: "red" }}>*</span></InputGroup.Text>
                <Form.Control type="password" name="password" value={formData.password}
                  className={`${errors.password ? "is-invalid" : ""}`}
                  disabled={!isEditable} onChange={handleChange} />
              </InputGroup>
            </Col>
            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: '200px', backgroundColor: "#e0ccff" }}>Confirm Password <span style={{ color: "red" }}>*</span></InputGroup.Text>
                <Form.Control type="password" name="confrimPwd" value={formData.confrimPwd}
                  className={`${errors.confrimPwd ? "is-invalid" : ""}`}
                  disabled={!isEditable} onChange={handleChange} />

              </InputGroup>
            </Col>

          </Row>

          {/* <Row>

            <Col md={6}>
              <InputGroup>
                <InputGroup.Text
                  style={{ width: '200px', backgroundColor: "#e0ccff" }}>User Type </InputGroup.Text> &nbsp;&nbsp;&nbsp;
                <input type='radio' name='userType' value={'Normal'} onChange={e => { setUserType(e.target.value) }}
                  checked={userType === 'Normal' ? true : false} disabled={!isEditable} ></input>
                <label htmlFor="userName" className="form-label"
                  style={{ paddingTop: '7px', width: '60px', marginLeft: '10px', marginRight: '30px' }}>Normal</label>
                <input type='radio' name='userType' value={'Admin'} onChange={e => { setUserType(e.target.value) }}
                  checked={userType === 'Admin' ? true : false} disabled={!isEditable} ></input>
                <label htmlFor="userName" className="form-label"
                  style={{ paddingTop: '7px', width: '50px', marginLeft: '10px', marginRight: '30px' }}>Admin</label>
                <input type='radio' name='userType' value={'Super_Admin'} onChange={e => { setUserType(e.target.value) }}
                  checked={userType === 'Super_Admin' ? true : false} disabled={!isEditable} ></input>
                <label htmlFor="userName" className="form-label"
                  style={{ paddingTop: '7px', width: '100px', marginLeft: '10px', marginRight: '30px' }}>Super Admin</label>
              </InputGroup>
            </Col>

          </Row> */}

        </Card.Body>
      {/* </Card>

      <Card className="p-3"> */}

        {/* <div className="table-wrapper"> */}
        <div style={{ minHeight: '220px' }} className="table-wrapper">

          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table">

            <thead >
              <tr>
                <th style={{ width: "5%", textAlign: "center", backgroundColor: "#e0ccff" }}>#</th>
                <th style={{ width: "50%", backgroundColor: "#e0ccff" }}>Role Name</th>
                {/* <th style={{ width: "12%" }}>Valid Till</th> */}
                <th style={{ width: "10%", backgroundColor: "#e0ccff" }}></th>
              </tr>
            </thead>

            <tbody>

              {roleDetails.map((row, index) => (

                <tr key={index}>

                  <td style={{ textAlign: "center" }}>{index + 1}</td>

                  <td>
                    <select
                      className="form-select"
                      //className={`form-select ${errors.rowErrors?.[index]?.kpi_id ? "is-invalid" : ""}`}
                      name="role"
                      value={row.role}
                      //disabled={!isDetailsEnabled}
                      disabled={roleDetails[index]?.user_id ? true : false}
                      //onChange={(e) => handleInputChange(index, e)}
                      onChange={e => handleRoleInputChange(index, 'role', e.target.value)}>
                      <option value="">-- Select Role --</option>
                      {roles.map((role) => (
                        <option key={role.role_id} value={role.role_id}>{role.role_name}</option>
                      ))}
                    </select>
                  </td>

                  <td style={{ textAlign: "center" }}>
                    {roleDetails.length > 1 && (
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => handleDeleteRow(index)}>Delete
                      </Button>
                    )}
                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

        <div className="d-flex justify-content-end mt-2">
          <OverlayTrigger placement="bottom"
            overlay={<Tooltip id="add-tooltip" style={{ backgroundColor: "#e9ecef" }}>Add Row</Tooltip>}>
            <Button variant="primary"
              onClick={handleAddRow}
              //disabled={!isDetailsEnabled}
              style={{
                width: "45px",
                height: "45px",
                borderRadius: "50%",
                padding: "0",
                fontSize: "30px"
              }}
            >
              +
            </Button>
          </OverlayTrigger>
        </div>

      </Card>

    </Container>
  );
};
export default New_Employe;
